import { APP_VIEW_ONLY_MESSAGE, useAppWriteAccess } from './useAppWriteAccess';

/** Toast / `title` text when recipe engagement writes are blocked (viewer on another profile). */
export const RECIPE_ENGAGEMENT_VIEW_ONLY_MESSAGE = APP_VIEW_ONLY_MESSAGE;

/**
 * True when the user may like/save/mutate collections for the selected family profile.
 * Uses `role` from GET /family/members (viewer on a dependent profile → false).
 */
export function useRecipeEngagementWriteAccess(): boolean {
  const { canWriteAppActions } = useAppWriteAccess();
  return canWriteAppActions;
}
